import apiClient from '../api';
import {
  Plan,
  CreatePlanRequest,
  UpdatePlanRequest,
  Feature,
  PlanFeatureMapping,
} from '../../../shared/adminFbacTypes';

// --- Plans API ---

export const getPlans = async (): Promise<Plan[]> => {
  const response = await apiClient.get<{ items: Plan[] }>('/TCAdminPlans');
  return response.data.items;
};

export const createPlan = async (plan: CreatePlanRequest): Promise<Plan> => {
  const response = await apiClient.post<{ item: Plan }>('/TCAdminPlans', plan);
  return response.data.item;
};

export const updatePlan = async (planId: string, plan: UpdatePlanRequest): Promise<Plan> => {
  const response = await apiClient.put<{ item: Plan }>(`/TCAdminPlans/${planId}`, plan);
  return response.data.item;
};

export const deletePlan = async (planId: string): Promise<void> => {
  await apiClient.delete(`/TCAdminPlans/${planId}`);
};

// --- Features & Mappings API ---

export const getFeatures = async (): Promise<Feature[]> => {
  // Fetch all features; assumes the total number is manageable for a client-side list.
  const response = await apiClient.get<{ items: Feature[] }>('/TCAdminFeatureCatalog?pageSize=1000');
  return response.data.items;
};

export const getPlanFeatures = async (planId: string): Promise<string[]> => {
  const response = await apiClient.get<{ items: PlanFeatureMapping[] }>(`/TCAdminPlans/${planId}/features`);
  return response.data.items.map(item => item.featureKey);
};

export const updatePlanFeatures = async (planId: string, featureKeys: string[]): Promise<void> => {
  await apiClient.put(`/TCAdminPlans/${planId}/features`, { featureKeys });
};